import { createEnvAccessor, isClient } from '@web-store-platforms/utils';

export { isClient as inClientMode };

// Portal uses dynamic process.env access (server-side rendering resolves at runtime),
// so no static env map is needed.
export const getEnvVariable = createEnvAccessor({});
